import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { signUp } from '../../redux/actions/authActions'
import { Link, useNavigate } from 'react-router-dom'
import styles from '../../sass/signin.module.scss'
import { Icons, IMG } from '../../constant'
import { toast } from 'react-toastify'

const SignUp = () => {
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      password_confirmation: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loader } = useSelector((state) => state.user);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignUp = () => {
    
    dispatch(signUp(formData))
    .unwrap()
    .then(() => {
      console.log('User signed up successfully');
      toast.success('You have signed up successfully');
      navigate(-1);
    })
    .catch((error) => {
      if (error.errors && typeof error.errors === 'object') {
        const errorMessages = Object.values(error.errors).flat(); // Convert errors object to an array of messages
        setError(errorMessages);
      } else {
          setError(error.message || 'Failed to reset password. Please try again.');
      }
    });
  };

  return (
    <div className={styles.AuthSectionContainer}>
      <div className={styles.AuthSectionContainer_body} style={{ backgroundImage: `url(${IMG.authblur})` }}>
        <img src={IMG.logo} className={styles.AuthSectionContainer_logo} alt='logo' />
        <h1 className={styles.AuthSectionContainer_title}>Create Your Account</h1>
        <p className={styles.AuthSectionContainer_subtitle}>Join DentalStores.in to access exclusive <br />offers and fast delivery.</p>

        <input
          type="text"
          name="name"
          placeholder="Enter your full name"
          className={styles.AuthSectionContainer_form_input}
          value={formData.name}
          onChange={handleChange}
        />

        <input
          type="email"
          name="email"
          placeholder="Enter your email address"
          className={styles.AuthSectionContainer_form_input}
          value={formData.email}
          onChange={handleChange}
        />
        
        <div className={styles.AuthSectionContainer_password_wrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="Enter your password"
            className={styles.AuthSectionContainer_form_input}
            value={formData.password}
            onChange={handleChange}
          />
          <div onClick={() => setShowPassword(!showPassword)} className={styles.AuthSectionContainer_password_icon}>
            {showPassword ? <img src={Icons.eyeFrame} alt='eyeFrame' /> : <img src={Icons.eyeSlash} alt='eyeslash' />}
          </div>
        </div>

        <div className={styles.AuthSectionContainer_password_wrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password_confirmation"
            placeholder="Enter your confirm password"
            className={styles.AuthSectionContainer_form_input}
            value={formData.password_confirmation}
            onChange={handleChange}
          />
          
        </div>
        

        <div className={styles.AuthSectionContainer_remfor_wrapper}>
            <div className={styles.AuthSectionContainer_remfor_body}>
              <input type="checkbox" className={styles.AuthSectionContainer_checkboxInput} />
              Remember me
            </div>
        </div>

        {loader ? (
          <button
            className={styles.ActionButton_fill}
            disabled
          >
            Please wait...
          </button>
        ) : (
          <button
            onClick={handleSignUp}
            className={styles.ActionButton_fill}
          >
            Sign Up
          </button>
        )}        

        {error && (
        <div className={styles.AuthSectionContainer_errors}>
            {Array.isArray(error)
            ? error.map((errMsg, index) => <div key={index}>{errMsg}</div>)
            : error}
        </div>
        )}

        <div className={styles.AuthSectionContainer_footer}>
          <span className="">Already have an account?</span>
          <Link to='/login' className={styles.AuthSectionContainer_link}>Log in</Link>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
